import { useEffect, useState } from "react";
import { DownloadSimple, FileCsv, Table as TableIcon } from "@phosphor-icons/react";
import api, { API } from "@/lib/api";
import { PageHeader, SectionTitle, Stat } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DatePicker } from "@/components/DatePicker";

const monthAgo = () => { const d = new Date(); d.setMonth(d.getMonth() - 1); return d.toISOString().slice(0, 10); };

export default function ActivityExport() {
  const [start, setStart] = useState(monthAgo());
  const [end, setEnd] = useState(new Date().toISOString().slice(0, 10));
  const [count, setCount] = useState(null);

  useEffect(() => { api.get("/audit", { params: { limit: 500 } }).then((r) => setCount(r.data.length)).catch(() => setCount(0)); }, []);

  const href = `${API}/export/activity/log?start=${start}&end=${end}`;

  return (
    <div className="space-y-6 max-w-2xl" data-testid="activity-export-page">
      <PageHeader overline="Activity" title="Export Log" subtitle="Pull a date-ranged activity log for internal review, an audit, or to share a summary with a bank partner" />

      <div className="grid grid-cols-2 gap-4">
        <Stat label="Events on record" value={count ?? "…"} testid="stat-export-events" />
        <Stat label="Selected range" value={`${start} → ${end}`} testid="stat-export-range" />
      </div>

      <Card className="p-6 border-border space-y-4">
        <SectionTitle icon={TableIcon}>Choose a date range</SectionTitle>
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="space-y-1.5"><Label>From</Label><DatePicker value={start} onChange={setStart} placeholder="Select date" className="w-full" data-testid="export-start" /></div>
          <div className="space-y-1.5"><Label>To</Label><DatePicker value={end} onChange={setEnd} placeholder="Select date" className="w-full" data-testid="export-end" /></div>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button asChild className="rounded-full bg-primary hover:bg-[#113A64]">
            <a href={href} data-testid="export-csv-btn"><FileCsv size={16} className="mr-1" /> Download CSV</a>
          </Button>
          <Button variant="outline" className="rounded-full" onClick={() => window.print()} data-testid="export-print-btn">
            <DownloadSimple size={16} className="mr-1" /> Print / Save as PDF
          </Button>
        </div>
        <p className="text-xs text-muted-foreground">The CSV opens straight in Excel with columns: time, who, action, record type, record id and details. For a PDF, use Print and choose "Save as PDF".</p>
      </Card>
    </div>
  );
}
